module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/trianglechallenges.json
// module id = 1046
// module chunks = 258677059948686